(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["filters-sorting"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.levelUpFilterDropdownsReady) return;
  window.levelUpFilterDropdownsReady = true;
  const selector = '.f8fl[data-warhammer-filters="true"] :is(h4[data-filter-toggle], div[data-legion-toggle])';

  const getPanel = (toggle) => {
    const panel = toggle.nextElementSibling;
    if (!panel) return null;
    if (panel.matches('.check, .input-range')) return panel;
    return null;
  };

  const setState = (toggle, panel, open) => {
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.hidden = !open;
  };

  const initialise = () => {
    document.querySelectorAll(selector).forEach((toggle) => {
      if (toggle.dataset.warhammerDropdownReady === 'true') return;
      const panel = getPanel(toggle);
      if (!panel) return;

      toggle.dataset.warhammerDropdownReady = 'true';
      toggle.setAttribute('role', 'button');
      toggle.setAttribute('tabindex', '0');
      panel.classList.add('warhammer-filter-panel');

      const hasActiveCheckbox = panel.querySelector('input[type="checkbox"]:checked') !== null;
      setState(toggle, panel, hasActiveCheckbox);
    });
  };

  const togglePanel = (toggle) => {
    const panel = getPanel(toggle);
    if (!panel) return;
    const open = toggle.getAttribute('aria-expanded') !== 'true';
    setState(toggle, panel, open);
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest(selector);
    if (!toggle) return;
    event.preventDefault();
    togglePanel(toggle);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const toggle = event.target.closest(selector);
    if (!toggle) return;
    event.preventDefault();
    togglePanel(toggle);
  });

  new MutationObserver(initialise).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  initialise();
})();
  } catch(e) { console.error(e); }
})();

})();
